module.exports = __webpack_public_path__ + "img/Firma_Maritza2.7fc5d44d.png";